import * as React from "react"
import { Checkbox } from "@/components/ui/checkbox"
import { cn } from "@/lib/utils"

export function CustomCheckbox({
  className,
  ...props
}: React.ComponentProps<typeof Checkbox>) {
  return (
    <Checkbox
      className={cn(
        // upstream base styles are already in the Checkbox component

        // add custom overrides here if needed
        // for example, to override checked state:
        // "data-[state=checked]:bg-custom-color",
          'hover:cursor-pointer',

        className
      )}
      {...props}
    />
  )
}

